import { DateTime } from 'luxon';
import _ from 'lodash';

export const stringComparator = (fn: (i: any) => string) => {
  return (i1: any, i2: any) => {
    return fn(i1) ? fn(i1).localeCompare(fn(i2)) : 1;
  };
};

export const dateComparator = (fn: (i: any) => DateTime) => {
  return (i1: any, i2: any) => {
    const min = DateTime.fromMillis(0);
    const v1 = fn(i1) || min;
    const v2 = fn(i2) || min;
    return v1 < v2 ? 1 : v1 > v2 ? -1 : 0;
  };
};

export const numberComparator = (fn: (i: any) => number) => {
  return (i1: any, i2: any) => {
    const v1 = fn(i1) || 0;
    const v2 = fn(i2) || 0;
    return v1 < v2 ? 1 : v1 > v2 ? -1 : 0;
  };
};

export const booleanComparator = (fn: (i: any) => boolean) => {
  return (i1: any, i2: any) => {
    const v1 = fn(i1) || false;
    const v2 = fn(i2) || false;
    return v1 === v2 ? 0 : v1 && !v2 ? 1 : -1;
  };
};

export const setComparator = (fn: (i: any) => Set<string>) => {
  return (i1: any, i2: any) => {
    const v1 = fn(i1);
    const v2 = fn(i2);
    return _.isEqual(v1, v2) ? 0 : v1.size > v2.size ? 1 : -1;
  };
};
